import React from "react";
import RecurringTransactionsList from "../components/transactions/RecurringTransactionsList";

const RecurringTransactionsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 mt-14">
      <RecurringTransactionsList />
    </div>
  );
};

export default RecurringTransactionsPage;
